<template>
  <div>

        <Pane />

    <a-card class="container">
      <div class="card">
      <div class="item">
          <div class="title">
            当月回款收入(万)
          </div>
          <div
            class="value"
          >{{ typeof monthSum === 'number' ? monthSum.toLocaleString() : '--' }}</div>
        </div>
        <div class="item">
          <div class="title">
            当年回款收入(万)
            <span class="extra">
              <MonthDialog />
            </span>
          </div>
          <div
            class="value"
          >{{ typeof yearSum	 === 'number' ? yearSum	.toLocaleString() : '--' }}</div>
        </div>
        <div class="item">
          <div class="title">
            当月考核回款收入(万)
            <span class="extra">
              <MonthDialog2 />
            </span>
          </div>
          <div
            class="value"
          >{{ typeof monthExamineSum === 'number' ? monthExamineSum.toLocaleString() : '--' }}</div>
        </div>
        <div class="item">
          <div class="title">
            当年考核回款收入(万)
            <span class="extra">
              <YearDialog @search="onSearch"/>
            </span>
          </div>
          <div
            class="value"
          >{{ typeof yearExamineSum === 'number' ? yearExamineSum.toLocaleString() : '--' }}</div>
        </div>
      </div>
      <Padding />
      <input
              ref="upload"
              style="display: none"
              type="file"
              :multiple="false"
              @change="onFileChange"
            />
      <a-form-model layout="inline" :colon="false" :model="form" @keyup.enter.native="query">
            <a-form-model-item label="项目名称">
              <ProjectSelector @change="onSelectProject">
                <a-button
                    block
                    style="text-align: left;"
                >{{ selectedProject.name ? selectedProject.name : '选择' }}</a-button>
              </ProjectSelector>
            </a-form-model-item>
            <a-form-model-item label="所属月份">
              <a-month-picker
                format="YYYY-MM"
                v-model="form.belongMonth"
                placeholder=""
                style="width: 150px"
              />
            </a-form-model-item>
            	<!-- 查询条件增加，设计编号、项目名称、责任部门，发生日期选择 -->
            <a-form-model-item label="责任部门">
              <a-select
                show-search
                :filter-option="$selectFilterOption"
                v-model="form.productionUnitId"
                style="width: 150px"
                placeholder=""
              >
                <a-select-option
                  v-for="item in productionDepartmentList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{
                  item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="发生日期">
              <a-range-picker
                v-model="form.dateRange"
                style="width: 300px"
              />
            </a-form-model-item>
            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
            <a-button v-if="$getPermission($route.path + '/edit')" type="primary" style="float: right;margin-top: 5px;" @click="download">导出收支</a-button>
            <a-button v-if="$getPermission($route.path + '/edit')" type="primary" style="float: right;margin-top: 5px;margin-right: 10px;" :loading="uploading" @click="importFile">批量导入收支</a-button>
            <a-button v-if="$getPermission($route.path + '/edit')" type="primary" style="float: right;margin-top: 5px;margin-right: 10px;" @click.prevent="$router.push($route.path + '/add')">新增收支</a-button>
            <a-button v-if="$getPermission($route.path + '/edit')" type="primary" style="float: right;margin-top: 5px;margin-right: 10px;" :loading="kanbanloading" @click="refreshKanban">刷新看板回款数据</a-button>
      </a-form-model>
      <Padding />

      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
                    total,
                    current,
                    pageSize,
                    showTotal: (total) => `共 ${total} 条记录`,
                  }"
        rowKey="id"
      >
        <a-table-column title="发生日期" data-index='date' width="100px"/>
        <a-table-column title="设计编号" data-index='project.designCode' align='center' width="120px"/>
        <a-table-column title="项目名称" data-index='project.name' />
        <a-table-column title="发生金额(万)"  align='right'>
          <template slot-scope="text">
            <Money :money="text.amount" />
          </template>
        </a-table-column>
        <a-table-column title="责任部门" data-index='productionUnitName' align='center' width="120px" />
        <a-table-column title="收支类型" align="center">
          <template slot-scope="text">
            <DataDictFinder dictType="project_fin_type" :dictValue="text.type" />
          </template>
        </a-table-column>
        <a-table-column title="经办人" data-index='handlerUserName' align='center' width="100px" />
        <a-table-column title="分包公司" data-index='companyName' />
        <a-table-column title="所属月份" data-index='belongMonth' width="80px"/>
        <a-table-column title="分配比例" data-index='allocateDesc' />


        <!-- <a-table-column title="未收入(万)"  align='right'>
          <template slot-scope="text">
             <Money :money="text.unearnedIncome" />
          </template>
        </a-table-column> -->
        

        <a-table-column align="center" title="操作" width="120px">
          <template slot-scope="text">
            <div>
              <a
                href="#"
                v-if="$getPermission($route.path + '/detail')"
                @click.prevent="$router.push($route.path + '/detail?id=' + text.id)"
              >查看</a>
              <a
                href="#"
                v-if="$getPermission($route.path + '/edit')"
                @click.prevent="$router.push($route.path + '/edit?id=' + text.id)"
                style="margin-left: 10px;"
              >编辑</a>
              <a
                href="#"
                v-if="$getPermission($route.path + '/edit')"
                @click.prevent="deleteList(text.id)"
                style="margin-left: 10px;color: red"
              >删除</a>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import moment from 'moment'
import organization from "@/mixins/organization";
import ProjectSelector from "@/components/project-selector";
import MonthDialog from "./components/monthDialog";
import MonthDialog2 from "./components/monthDialog2";
import YearDialog from "./components/yearDialog";
import axios from 'axios'
import download from '@/api/download'
import { saveAs } from "file-saver";
function fetchList(data) {
  return request({
       url: '/project-service/projectFin/list2',
       method: "post",
       data
  });
}

const instance = axios.create({
  responseType: 'blob',
})
function upload(data) {
  return instance({
    url: "/project-service/projectFin/import",
    method: 'post',
    headers: {
      token: window.localStorage.getItem('token')
    },
    data,
  });
}
// function upload(data) {
//   return request({
//     url: "/project-service/projectFin/import",
//     method: "post",
//     data,
//   });
// }

function deleteList(id) {
  return request({
       url: '/project-service/projectFin/del/' + id,
       method: "post",
  });
}
function kanbanRefresh() {
  return request({
       url: '/project-service/projectFin/refresh',
       method: "post",
  });
}
function fetchSum() {
  return request({
       url: '/project-service/projectFin/sum',
       method: "post",
  });
}
function exportFile(data) {
  return download({
    url: "/project-service//projectFin/export",
    method: "post",
    data
  });
}

export default {
  mixins: [ watermark,organization],

  components: {
    ProjectSelector,
    MonthDialog,
    YearDialog,
    MonthDialog2
  },
  data() {
    return {
      monthExamineSum: 0,
      monthSum: 0,
      yearExamineSum: 0,
      yearSum: 0,
      historyAnnualData: [],
      historyProfit: 0,
      statistic: [],
      statisticProfit: 0,
      month: moment().format("YYYY-MM"),

      form: {},
      selectedMonthList: [],
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      uploading: false,
      kanbanloading: false,
      selectedProject: {},
    };
  },

  computed: {
    monthObj() {
        const item = this.statistic.find(item => item.date === this.month);
        console.log('item',item)
        return item ? item : {}
    }
  },

  mounted() {
    this.selectedMonthList = [moment().format("YYYY") + '-' + '01', '']
    this.getList();
  },

  methods: {
    download() {
        this.loading = true;
        exportFile({
          pageNum: this.current,
          pageSize: this.pageSize,
          ...this.form,
          belongMonth: this.form.belongMonth? this.form.belongMonth.format("YYYY-MM") : '',
          startDate: this.form.dateRange ? this.form.dateRange[0].format("YYYY-MM-DD") : '',
          endDate: this.form.dateRange ? this.form.dateRange[1].format("YYYY-MM-DD") : '',
        })
        .then(blob => {
            saveAs(blob, "收支详情.xlsx");
            this.loading = false;
        });
    },
    refreshKanban() {
      this.kanbanloading = true;
      kanbanRefresh()
        .then(() => {

        })
        .finally(() => {
          this.kanbanloading = false;
        });
    },
    deleteList(id) {
      this.$confirm({
        title: "删除确认",
        content: "确认删除该条记录吗？",
        onOk: () => {
          deleteList(id)
            .then(() => {
              this.getList();
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        },
        onCancel: () => {}
      })
    },
    onSelectProject(value) {
      console.log("value", value);
      this.selectedProject = value;
      this.form.projectId = value.id;
    },
    monthPanelChange(values) {
      if (values.length === 2) {
        this.selectedMonthList = [
          moment(values[0]).format("YYYY-MM"),
          moment(values[1]).format("YYYY-MM")
        ]
        this.form = {
          ...this.form,
          monthStart: moment(values[0]).format("YYYY-MM"),
          monthEnd: moment(values[1]).format("YYYY-MM"),
        };
      }
    },
    importFile() {
      this.$refs.upload.click();
    },
    onFileChange(e) {
      const files = e.target.files;
      const data = new FormData();
      for (let i = 0; i < files.length; i++) {
        data.append("file", files[i]);
      }

      this.uploading = true;

      upload(data)
        .then((res) => {
          const link = document.createElement('a'); // 创建元素
          let blob = new Blob([res.data]);
          link.style.display='none';
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download','结果'+files[0].name) // 为下载后的文件命名
          document.body.appendChild(link)
          link.click(); // 点击下载
          document.body.removeChild(link) // 下载完成后移除元素
          window.URL.revokeObjectURL(link.href) // 释放blob对象
        })
        .finally(() => {
          this.uploading = false;
          e.target.value = null;
        });
    },
    getList() {
      const { current, pageSize } = this;
      this.loading = true;
      fetchSum()
      .then(res => {
        this.monthSum = res.monthSum ? res.monthSum/10000 : 0;
        this.monthExamineSum = res.monthExamineSum ? res.monthExamineSum/10000 : 0;
        this.yearSum = res.yearSum ? res.yearSum/10000 : 0;
        this.yearExamineSum = res.yearExamineSum ? res.yearExamineSum/10000 : 0;
      })
      fetchList({
        pageNum: current,
        pageSize: pageSize,
        ...this.form,
        belongMonth: this.form.belongMonth? this.form.belongMonth.format("YYYY-MM") : '',
        startDate: this.form.dateRange ? this.form.dateRange[0].format("YYYY-MM-DD") : '',
        endDate: this.form.dateRange ? this.form.dateRange[1].format("YYYY-MM-DD") : '',
      })
        .then(res => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize ? res.totalSize : 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },


    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.selectedMonthList = ['', '']
      this.getList();
    },

  }
};
</script>
<style lang="less" scoped>
.card {
  display: flex;

  .item {
    border: 2px solid #f0f0f0;
    margin-right: 12px;
    padding: 12px;
    border-radius: 2px;
    min-width: 240px;
    position: relative;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .extra {
        margin-left: auto;
        cursor: pointer;
      }
    }

    .value {
      font-size: 2em;
      color: #1890ff;
    }

    .setting {
      position: absolute;
      bottom: 12px;
      right: 12px;
      cursor: pointer;
    }
  }

  .active {
    border-color: #1890ff;
  }
}
</style>